// extracted by mini-css-extract-plugin
export default {"container":"styles_container__R+jzt","close":"styles_close__PUjKG","text":"styles_text__4xyHA","button":"styles_button__11HSy"};